/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WaitlistUnsubscribeResponse interface.
 */
export function instanceOfWaitlistUnsubscribeResponse(value) {
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
export function WaitlistUnsubscribeResponseFromJSON(json) {
    return WaitlistUnsubscribeResponseFromJSONTyped(json, false);
}
export function WaitlistUnsubscribeResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'message': json['message'],
    };
}
export function WaitlistUnsubscribeResponseToJSON(json) {
    return WaitlistUnsubscribeResponseToJSONTyped(json, false);
}
export function WaitlistUnsubscribeResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'message': value['message'],
    };
}
